import { CheckCircleFilled } from '@ant-design/icons';
import { getStaticCDN } from '@design-system/utils/utils';
import { URL_CONFIG } from '@source/constants/urlConfig';
import { TLanguageKey } from '@source/interface';

// eslint-disable-next-line import/prefer-default-export
export const BRAND_NEW_BANNER_CONTENT = (lang: TLanguageKey) => ({
  sg: {
    title: 'shared.brandNewBanner.brandNew',
    isTitleLine: false,
    body: [
      {
        key: 'noCEO',
        text: {
          desktop: 'shared.brandNewBanner.noCOEDesktop',
          mobile: 'shared.brandNewBanner.noCOEMobile',
        },
        icon: {
          desktop: getStaticCDN('/assets/shared/browse/brand-new-banner/no-coe-top-up.svg'),
          mobile: <CheckCircleFilled />,
        },
      },
      {
        key: 'noAdminFees',
        text: {
          desktop: 'shared.brandNewBanner.noAdminFeesDesktop',
          mobile: 'shared.brandNewBanner.noAdminFeesMobile',
        },
        icon: {
          desktop: getStaticCDN('/assets/shared/browse/brand-new-banner/no-admin-fees.svg'),
          mobile: <CheckCircleFilled />,
        },
      },
      {
        key: 'warranty',
        text: {
          desktop: 'shared.brandNewBanner.warrantyEngineGearboxDesktop',
          mobile: 'shared.brandNewBanner.warrantyEngineGearboxMobile',
        },
        icon: {
          desktop: getStaticCDN('/assets/shared/browse/brand-new-banner/10-years-warranty.svg'),
          mobile: <CheckCircleFilled />,
        },
      },
      {
        key: 'zeroDownPayment',
        text: {
          desktop: 'shared.brandNewBanner.zeroDownPaymentDesktop',
          mobile: 'shared.brandNewBanner.zeroDownPaymentMobile',
        },
        icon: {
          desktop: getStaticCDN('/assets/shared/browse/brand-new-banner/zero-downpayment.svg'),
          mobile: <CheckCircleFilled />,
        },
      },
    ],
    linkUrl: URL_CONFIG({ region: 'sg', lang, path: 'buy-new' }).formatted,
  },
});
